module.exports = __webpack_public_path__ + "img/web_ncyu_4.10abf246.jpg";